import { Component, OnDestroy, ChangeDetectionStrategy, inject } from "@angular/core";
import {CookieService} from "ngx-cookie-service";
import {Router} from "@angular/router";
import {QdmService} from "../Services/qdm.service";
import {GestionService} from "../Services/gestion.service";
import {ToastrService} from "ngx-toastr";
import {AuthService} from "../Services/auth.service";
import {Subscription} from "rxjs";

@Component({
  standalone: true,
  selector: "OrderSuccessCallback",
  templateUrl: "./OrderSuccessCallback.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./OrderSuccessCallback.component.scss"]
})
export class OrderSuccessCallback implements OnDestroy{
  private cookie = inject(CookieService);
  private router = inject(Router);
  private qdm = inject(QdmService);
  private gestion = inject(GestionService);
  private toast = inject(ToastrService);
  private auth = inject(AuthService);


  sub: Subscription = new Subscription();

  ngOnInit() {
    // Vérifier d'abord s'il y a une navigation en attente après rechargement
    const pendingRestaurantId = localStorage.getItem('pendingRestaurantNavigation');
    if (pendingRestaurantId) {
      localStorage.removeItem('pendingRestaurantNavigation');
      
      // Charger les données fraîches du restaurant
      this.qdm.listRestaurantsForCurrentDomain();
      this.sub.add(this.qdm.restaurants$.subscribe(restaurants => {
        if(restaurants.length === 0) return;
        
        const restaurant = restaurants.find((restaurant) => restaurant.id === parseInt(pendingRestaurantId));
        if(!restaurant){
          console.warn("restaurant not found");
          this.router.navigate(["/"]);
          return;
        }
        
        console.warn("selecting restaurant and navigating with fresh data");
        this.qdm.selectRestaurant(restaurant);
        this.router.navigate(["/restaurant", pendingRestaurantId]);
        this.toast.info("Votre commande a bien été enregistrée !", "Commande enregistrée", { positionClass: "toast-bottom-right-cart" });
      }));
      return; // Sortir tôt car la navigation est gérée
    }
    
    // Logique originale
    const user = this.auth.userSubject.value;
    if(!user){
      this.router.navigate(["/"]);
      console.warn("no user");
      return;
    }
    
    const userEnterpriseSubject = this.auth.userEnterpriseSubject.value;
    if(!userEnterpriseSubject){
      this.router.navigate(["/"]);
      alert("no user enterprise");
      return;
    }
  
    this.gestion.fetchCommandsHistory(userEnterpriseSubject.id, true).then(h => {
      if(!this.cookie.check("lastOrderRestaurant")){
        this.router.navigate(["/"]);
        console.warn("no last order restaurant");
        return;
      }
  
      const lastOrderRestaurant = this.cookie.get("lastOrderRestaurant");
      this.cookie.delete("lastOrderRestaurant", "/");
  
      console.warn("lastOrderRestaurant: " + lastOrderRestaurant);
      
      // Stocker l'ID du restaurant dans localStorage pour y accéder après rechargement
      localStorage.setItem('pendingRestaurantNavigation', lastOrderRestaurant);
      
      // Recharger la page avant de naviguer
      window.location.reload();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
